import React, { useState, useEffect } from 'react';
import { useTheme } from './ThemeContext';
import { adminAction, adminSavePrompts, setUserRole } from './api';
import {
  chatAdminListStreams, chatAdminCreateStream, chatAdminUpdateStream, chatAdminDeleteStream,
  chatAdminAddMember, chatAdminRemoveMember, chatAdminAddMentor, chatAdminRemoveMentor,
  chatAdminListUsers
} from './api';
import { Icons } from './icons';

const ADMIN_PASSWORD = 'doloyves';
const BUCKET_NAME = 'ai-nutrition-app';

// SVG-иконки для меню (не из Icons, чтобы не путать)
const UsersIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const PromptsIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
  </svg>
);
const TipsIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 1 1 7.072 0l-.548.547A3.374 3.374 0 0 0 14 18.469V19a2 2 0 1 1-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
  </svg>
);
const MentorIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
  </svg>
);
const SunIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);
const MoonIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);
const LogoutIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);
const PromoIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);

const KeyIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="7.5" cy="15.5" r="5.5"/><path d="M21 2l-9.6 9.6"/><path d="M15.5 7.5l3 3L22 7l-3-3"/>
  </svg>
);

const StreamsIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

function Admin({ onBack }) {
  const { toggleTheme } = useTheme();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [activeTab, setActiveTab] = useState('users');
  const [prompt1, setPrompt1] = useState('');
  const [prompt2Ate, setPrompt2Ate] = useState('');
  const [prompt2Plan, setPrompt2Plan] = useState('');
  const [recommendations, setRecommendations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showRecForm, setShowRecForm] = useState(false);
  const [editingRec, setEditingRec] = useState(null);
  const [recForm, setRecForm] = useState({ id: null, categoryId: 'nutrition', title: '', content: '' });
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [promocodes, setPromocodes] = useState([]);
  const [newPromoCode, setNewPromoCode] = useState('');
  const [newPromoName, setNewPromoName] = useState('Премиум');
  const [newPromoSkLimit, setNewPromoSkLimit] = useState(30);
  const [newPromoDsLimit, setNewPromoDsLimit] = useState(100);
  const [newPromoDuration, setNewPromoDuration] = useState(1);
  const [newPromoExpires, setNewPromoExpires] = useState('');
  const [newPromoMaxUses, setNewPromoMaxUses] = useState(10);
  const [inviteCodes, setInviteCodes] = useState([]);
  const [newInviteCode, setNewInviteCode] = useState('');
  // Потоки чата
  const [streams, setStreams] = useState([]);
  const [streamUsers, setStreamUsers] = useState([]); // [{login, role}] — кандидаты в потоки
  const [loadingStreams, setLoadingStreams] = useState(false);
  const [newStreamName, setNewStreamName] = useState('');
  const [renamingId, setRenamingId] = useState(null);
  const [renameValue, setRenameValue] = useState('');
  const [editingStreamId, setEditingStreamId] = useState(null); // раскрытая карточка
  const [addLoginFor, setAddLoginFor] = useState(''); // выбранный логин
  const [addRoleFor, setAddRoleFor] = useState('member'); // 'member' | 'mentor'
  // Мини-меню выбора потока у пользователя (вкладка «Пользователи»)
  // { login, kind: 'member' | 'mentor' } | null
  const [streamPicker, setStreamPicker] = useState(null);
  const [busyStreamAction, setBusyStreamAction] = useState(false);
  const [message, setMessage] = useState('');
  const [saveBtnText, setSaveBtnText] = useState('Сохранить все промпты');
  const [isDark, setIsDark] = useState(true);

  useEffect(() => { if (message) { const t = setTimeout(() => setMessage(''), 3000); return () => clearTimeout(t); } }, [message]);
  useEffect(() => { if (isAuthenticated) { loadPrompts(); loadRecommendations(); loadUsers(); loadStreams(); } }, [isAuthenticated]);

  // Theme detection
  useEffect(() => {
    const isDarkMode = document.documentElement.getAttribute('data-theme') !== 'light';
    setIsDark(!isDarkMode === false ? true : isDarkMode);
  }, []);

  const handleThemeToggle = () => {
    setIsDark(!isDark);
    toggleTheme();
  };

  const loadPrompts = async () => {
    try {
      const [p1, p2a, p2p] = await Promise.all([
        fetch(`https://storage.yandexcloud.net/${BUCKET_NAME}/prompt1.txt?t=${Date.now()}`).then(r => r.ok ? r.text() : ''),
        fetch(`https://storage.yandexcloud.net/${BUCKET_NAME}/prompt2_ate.txt?t=${Date.now()}`).then(r => r.ok ? r.text() : ''),
        fetch(`https://storage.yandexcloud.net/${BUCKET_NAME}/prompt2_plan.txt?t=${Date.now()}`).then(r => r.ok ? r.text() : '')
      ]);
      setPrompt1(p1); setPrompt2Ate(p2a); setPrompt2Plan(p2p);
    } catch (e) { console.error('Ошибка загрузки промптов:', e); }
  };

  const loadRecommendations = async () => {
    try {
      const r = await fetch(`https://storage.yandexcloud.net/${BUCKET_NAME}/recommendations.json?t=${Date.now()}`);
      if (r.ok) { const d = await r.json(); setCategories(d.categories || []); setRecommendations(d.recommendations || []); }
    } catch (e) { console.error('Ошибка загрузки рекомендаций:', e); }
  };

  const loadUsers = async () => {
    setLoadingUsers(true);
    try {
      const d = await adminAction(ADMIN_PASSWORD, 'list');
      if (d.success) setUsers(d.users || []);
    } catch (e) { console.error('Ошибка загрузки пользователей:', e); }
    setLoadingUsers(false);
  };

  const refreshUsersTab = async () => { await Promise.all([loadUsers(), loadStreams()]); };

  // === ПОТОКИ ЧАТА ===
  const loadStreams = async () => {
    setLoadingStreams(true);
    try {
      const d = await chatAdminListStreams(ADMIN_PASSWORD);
      if (d.success) {
        setStreams(d.streams || []);
        setMessage('');
      } else setMessage((d.error || 'Ошибка загрузки потоков'));
    } catch (e) { setMessage('Не удалось связаться с сервером чата'); }
    setLoadingStreams(false);
  };

  const loadStreamCandidates = async () => {
    try {
      const d = await chatAdminListUsers(ADMIN_PASSWORD);
      if (d.success) setStreamUsers(d.users || []);
    } catch (e) { /* тихо */ }
  };

  const createStream = async () => {
    const name = newStreamName.trim();
    if (!name) { setMessage('Укажите название потока'); return; }
    const d = await chatAdminCreateStream(ADMIN_PASSWORD, name);
    if (d.success) { setMessage(`Поток «${name}» создан`); setNewStreamName(''); loadStreams(); }
    else setMessage((d.error || 'Ошибка'));
  };

  const renameStream = async (streamId) => {
    const name = renameValue.trim();
    if (!name) { setMessage('Введите название'); return; }
    const d = await chatAdminUpdateStream(ADMIN_PASSWORD, streamId, name);
    if (d.success) { setMessage('Поток переименован'); setRenamingId(null); loadStreams(); }
    else setMessage((d.error || 'Ошибка'));
  };

  const deleteStream = async (stream) => {
    if (!window.confirm(`Удалить поток «${stream.name}» и его ленту сообщений?`)) return;
    const d = await chatAdminDeleteStream(ADMIN_PASSWORD, stream.id);
    if (d.success) { setMessage(`Поток «${stream.name}» удалён`); setEditingStreamId(null); loadStreams(); }
    else setMessage((d.error || 'Ошибка'));
  };

  const addPerson = async (streamId) => {
    if (!addLoginFor) { setMessage('Выберите логин'); return; }
    const d = addRoleFor === 'member'
      ? await chatAdminAddMember(ADMIN_PASSWORD, streamId, addLoginFor)
      : await chatAdminAddMentor(ADMIN_PASSWORD, streamId, addLoginFor);
    if (d.success) { setMessage(`${addLoginFor} добавлен`); setAddLoginFor(''); loadStreams(); }
    else setMessage((d.error || 'Ошибка'));
  };

  const removePerson = async (stream, login, kind) => {
    const d = kind === 'member'
      ? await chatAdminRemoveMember(ADMIN_PASSWORD, stream.id, login)
      : await chatAdminRemoveMentor(ADMIN_PASSWORD, stream.id, login);
    if (d.success) { setMessage(`${login} убран из «${stream.name}»`); loadStreams(); }
    else setMessage((d.error || 'Ошибка'));
  };

  // ===== ПОТОКИ ЧЕРЕЗ ВКЛАДКУ «ПОЛЬЗОВАТЕЛИ» =====
  const MAX_MEMBERS = 10;

  // Где человек сейчас: участник и/или наставник (по всем потокам)
  const streamsOf = (login) => {
    const asMember = streams.filter(st => (st.members || []).includes(login));
    const asMentor = streams.filter(st => (st.mentors || []).includes(login));
    return { asMember, asMentor };
  };

  // Роль в колонке — вычисляемая из потоков (поле role в базе не трогаем)
  const effectiveRole = (login) =>
    streams.some(st => (st.mentors || []).includes(login)) ? 'mentor' : 'user';

  const isMemberOf = (login, streamId) => {
    const st = streams.find(s => s.id === streamId);
    return !!(st && (st.members || []).includes(login));
  };

  const isMentorOf = (login, streamId) => {
    const st = streams.find(s => s.id === streamId);
    return !!(st && (st.mentors || []).includes(login));
  };

  const closeStreamPicker = () => setStreamPicker(null);

  // Участник: может быть только в ОДНОМ потоке. Переполненные — убраны из списка,
  // у остальных видно «(7/10)».
  const chooseMemberStream = async (login, stream) => {
    if (busyStreamAction) return;
    if (isMemberOf(login, stream.id)) {
      if (!window.confirm(`Убрать ${login} из потока «${stream.name}»?`)) return;
      setBusyStreamAction(true);
      const d = await chatAdminRemoveMember(ADMIN_PASSWORD, stream.id, login);
      setBusyStreamAction(false);
      setStreamPicker(null);
      if (d.success) { setMessage(`${login} убран из «${stream.name}»`); refreshUsersTab(); }
      else setMessage((d.error || 'Ошибка'));
      return;
    }
    const current = streamsOf(login).asMember;
    if (current.length > 0) {
      const from = current[0].name;
      if (!window.confirm(`Перевести ${login} из «${from}» в «${stream.name}»?\nПользователь может быть только в одном потоке.`)) return;
    }
    setBusyStreamAction(true);
    for (const st of current) await chatAdminRemoveMember(ADMIN_PASSWORD, st.id, login);
    const d = await chatAdminAddMember(ADMIN_PASSWORD, stream.id, login);
    setBusyStreamAction(false);
    setStreamPicker(null);
    if (d.success) { setMessage(`${login} — участник «${stream.name}»`); refreshUsersTab(); }
    else setMessage((d.error || 'Ошибка'));
  };

  // Наставник: может вести один или несколько потоков — переключатель по каждому.
  const toggleMentorStream = async (login, stream) => {
    if (busyStreamAction) return;
    const isMentor = isMentorOf(login, stream.id);
    if (isMentor && !window.confirm(`Убрать ${login} из наставников потока «${stream.name}»?`)) return;
    setBusyStreamAction(true);
    const d = isMentor
      ? await chatAdminRemoveMentor(ADMIN_PASSWORD, stream.id, login)
      : await chatAdminAddMentor(ADMIN_PASSWORD, stream.id, login);
    setBusyStreamAction(false);
    if (d.success) {
      setMessage(isMentor ? `${login} больше не наставник «${stream.name}»` : `${login} — наставник «${stream.name}»`);
      refreshUsersTab();
    } else setMessage((d.error || 'Ошибка'));
  };

  const saveRecs = async (newRecs, newCats) => {
    const data = { categories: newCats || categories, recommendations: newRecs || recommendations };
    const r = await adminSavePrompts(ADMIN_PASSWORD, { recommendations: JSON.stringify(data, null, 2) });
    if (!r.success) throw new Error(r.error || 'Ошибка сохранения');
  };

  const handleSavePrompts = async () => {
    setIsLoading(true);
    try {
      const r = await adminSavePrompts(ADMIN_PASSWORD, { prompt1, prompt2: prompt2Ate, prompt3: prompt2Plan });
      if (r.success) { setSaveBtnText('Сохранено'); setTimeout(() => setSaveBtnText('Сохранить все промпты'), 3000); }
    } catch (e) {}
    setIsLoading(false);
  };

  const handleAddRec = async () => {
    if (!recForm.title || !recForm.content) { setMessage('Заполните заголовок и содержание'); return; }
    const newRec = { ...recForm, id: Date.now().toString() };
    try { await saveRecs([...recommendations, newRec]); setRecommendations([...recommendations, newRec]); setShowRecForm(false); setMessage('Совет добавлен'); }
    catch (e) { setMessage(e.message); }
  };

  const handleEditRec = (rec) => { setEditingRec(rec); setRecForm(rec); setShowRecForm(true); };

  const handleUpdateRec = async () => {
    if (!recForm.title || !recForm.content) { setMessage('Заполните заголовок и содержание'); return; }
    const newRecs = recommendations.map(r => r.id === editingRec.id ? recForm : r);
    try { await saveRecs(newRecs); setRecommendations(newRecs); setShowRecForm(false); setEditingRec(null); setMessage('Совет обновлён'); }
    catch (e) { setMessage(e.message); }
  };

  const handleDeleteRec = async (id) => {
    const newRecs = recommendations.filter(r => r.id !== id);
    try { await saveRecs(newRecs); setRecommendations(newRecs); setMessage('Совет удалён'); }
    catch (e) { setMessage(e.message); }
  };

  const handleSaveRecommendations = async () => {
    setIsLoading(true);
    try { await saveRecs(); setSaveBtnText('Сохранено'); setTimeout(() => setSaveBtnText('Сохранить советы'), 3000); }
    catch (e) {}
    setIsLoading(false);
  };

  const handleBlockUser = async (login) => {
    const d = await adminAction(ADMIN_PASSWORD, 'block', { login });
    if (d.success) { setMessage(`${login} заблокирован`); loadUsers(); } else setMessage((d.error || 'Ошибка'));
  };

  const handleUnblockUser = async (login) => {
    const d = await adminAction(ADMIN_PASSWORD, 'unblock', { login });
    if (d.success) { setMessage(`${login} разблокирован`); loadUsers(); } else setMessage((d.error || 'Ошибка'));
  };

  const handleResetPassword = async () => {
    if (!newPassword || newPassword.length < 4) { setMessage('Пароль от 4 символов'); return; }
    setIsLoading(true);
    const d = await adminAction(ADMIN_PASSWORD, 'resetPassword', { login: selectedUser.login, newPassword });
    if (d.success) { setMessage(`Пароль ${selectedUser.login} сброшен`); setShowResetModal(false); } else setMessage((d.error || 'Ошибка'));
    setIsLoading(false);
  };

  const handleDeleteUser = async (login) => {
    if (!window.confirm(`Удалить пользователя ${login}?`)) return;
    const d = await adminAction(ADMIN_PASSWORD, 'delete', { login });
    if (d.success) { setMessage(`${login} удалён`); loadUsers(); } else setMessage((d.error || 'Ошибка'));
  };

  const handleSetRole = async (login, role) => {
    const d = await setUserRole(ADMIN_PASSWORD, login, role);
    if (d.success) { setMessage(`Роль ${login} изменена на ${role === 'mentor' ? 'Наставник' : 'Пользователь'}`); loadUsers(); } else setMessage((d.error || 'Ошибка'));
  };

  const handleLogin = (e) => { e.preventDefault(); if (password === ADMIN_PASSWORD) setIsAuthenticated(true); else setMessage('Неверный пароль'); };

  const bg = isDark ? '#0f0f0f' : '#f5f5f5';
  const sidebarBg = isDark ? '#1a1a2e' : '#ffffff';
  const cardBg = isDark ? '#16213e' : '#f0f0f0';
  const accent = '#1D9E75';
  const textColor = isDark ? '#eee' : '#222';
  const mutedColor = isDark ? '#888' : '#999';
  const borderColor = isDark ? '#2a2a3e' : '#ddd';
  const hoverBg = isDark ? 'rgba(29,158,117,0.15)' : 'rgba(29,158,117,0.08)';

  if (!isAuthenticated) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: bg }}>
        <div style={{ background: sidebarBg, borderRadius: 20, padding: 40, width: 400, boxShadow: isDark ? 'none' : '0 2px 20px rgba(0,0,0,0.1)' }}>
          <div style={{ fontSize: 22, fontWeight: 600, color: textColor, textAlign: 'center', marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <Icons.lock size={22} color={accent} /> Админ-панель
          </div>
          <form onSubmit={handleLogin}>
            <input style={{ width: '100%', padding: '12px 16px', fontSize: 14, border: `1px solid ${borderColor}`, borderRadius: 12, background: cardBg, color: textColor, outline: 'none', boxSizing: 'border-box' }} type="password" placeholder="Пароль администратора" value={password} onChange={e => setPassword(e.target.value)} autoFocus />
            <button type="submit" style={{ width: '100%', padding: 12, background: accent, color: 'white', border: 'none', borderRadius: 12, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 12 }}>Войти</button>
          </form>
          {message && <div style={{ padding: '10px 16px', borderRadius: 12, fontSize: 14, textAlign: 'center', background: '#5c1a1a', color: '#ff6b6b', marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}><Icons.warning size={16} color="#ff6b6b" /><span>{message}</span></div>}
        </div>
      </div>
    );
  }

  const mentors = users.filter(u => u.role === 'mentor');

  const sidebarItems = [
    { key: 'streams', label: 'Потоки', icon: StreamsIcon, count: streams.length },
    { key: 'users', label: 'Пользователи', icon: UsersIcon, count: users.length },
    { key: 'mentors', label: 'Наставники', icon: MentorIcon, count: mentors.length },
    { key: 'prompts', label: 'Промпты', icon: PromptsIcon },
    { key: 'promocodes', label: 'Промокоды', icon: PromoIcon, count: promocodes.length },
    { key: 'invitecodes', label: 'Коды', icon: KeyIcon, count: inviteCodes.length },
    { key: 'recommendations', label: 'Советы', icon: TipsIcon, count: recommendations.length },
  ];

  // ===== STYLES =====
  const sidebarStyle = {
    width: 220, background: sidebarBg, borderRight: `1px solid ${borderColor}`,
    display: 'flex', flexDirection: 'column', color: textColor, fontFamily: 'system-ui, sans-serif'
  };
  const headerStyle = {
    padding: '20px 20px 16px', borderBottom: `1px solid ${borderColor}`, marginBottom: 8
  };
  const navItemStyle = (isActive) => ({
    display: 'flex', alignItems: 'center', gap: 10, padding: '10px 20px', border: 'none',
    background: isActive ? hoverBg : 'transparent', color: isActive ? accent : textColor,
    fontSize: 14, cursor: 'pointer', textAlign: 'left', width: '100%',
    borderLeft: isActive ? `3px solid ${accent}` : '3px solid transparent'
  });
  const badgeStyle = {
    marginLeft: 'auto', background: isDark ? '#333' : '#e0e0e0',
    padding: '2px 8px', borderRadius: 10, fontSize: 11, color: mutedColor
  };
  const footerStyle = {
    marginTop: 'auto', padding: '16px 20px', borderTop: `1px solid ${borderColor}`
  };
  const contentCardStyle = {
    maxWidth: 1000, margin: '0 auto', background: sidebarBg, borderRadius: 16,
    padding: 24, height: 'calc(100vh - 48px)', display: 'flex', flexDirection: 'column',
    boxShadow: isDark ? 'none' : '0 2px 20px rgba(0,0,0,0.08)'
  };
  const scrollAreaStyle = {
    flex: 1, overflowY: 'auto', marginTop: 16, scrollbarWidth: 'thin', scrollbarColor: 'transparent transparent',
  };
  const btnStyle = {
    padding: '8px 20px', background: accent, color: 'white', border: 'none',
    borderRadius: 10, fontSize: 13, fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6
  };
  const inputStyle = {
    width: '100%', padding: '10px 14px', fontSize: 13, border: `1px solid ${borderColor}`,
    borderRadius: 10, background: cardBg, color: textColor, outline: 'none', boxSizing: 'border-box'
  };
  const tableHeaderStyle = {
    display: 'grid', gridTemplateColumns: '1fr 92px 88px 92px 102px 92px 159px',
    padding: '10px 12px', borderBottom: `1px solid ${borderColor}`,
    fontSize: 11, color: mutedColor, fontWeight: 600, columnGap: 0
  };
  const tableRowStyle = {
    display: 'grid', gridTemplateColumns: '1fr 92px 88px 92px 102px 92px 159px',
    padding: '8px 12px', borderBottom: `1px solid ${borderColor}`,
    alignItems: 'center', fontSize: 13, columnGap: 0
  };

  // ISO-дата → "дд.мм.гггг" (по локальному времени пользователя)
  const formatRegDate = (iso) => {
    try {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return '—';
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      return `${dd}.${mm}.${d.getFullYear()}`;
    } catch { return '—'; }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: bg, color: textColor, fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {/* SIDEBAR */}
      <div style={sidebarStyle}>
        <div style={headerStyle}>
          <div style={{ fontSize: 16, fontWeight: 600, color: accent, display: 'flex', alignItems: 'center', gap: 6 }}>
            <Icons.lock size={18} color={accent} /> Админ-панель
          </div>
          <div style={{ fontSize: 11, color: mutedColor, marginTop: 4 }}>nutrition-app</div>
        </div>

        {sidebarItems.map(item => (
          <button key={item.key} onClick={() => { setActiveTab(item.key); setStreamPicker(null); if (item.key === 'users' || item.key === 'streams') { loadUsers(); loadStreams(); } setSaveBtnText(item.key === 'prompts' ? 'Сохранить все промпты' : item.key === 'recommendations' ? 'Сохранить советы' : ''); }} style={navItemStyle(activeTab === item.key)}>
            <item.icon color={activeTab === item.key ? accent : mutedColor} />
            <span>{item.label}</span>
            {item.count !== undefined && <span style={badgeStyle}>{item.count}</span>}
          </button>
        ))}

        <div style={footerStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', width: '100%', marginBottom: 4 }}>
            <SunIcon color={isDark ? mutedColor : '#f39c12'} />
            <div onClick={handleThemeToggle} style={{ position: 'relative', width: 36, height: 20, background: isDark ? '#333' : '#ccc', borderRadius: 10, cursor: 'pointer', transition: '0.2s', flexShrink: 0 }}>
              <div style={{ position: 'absolute', top: 2, left: isDark ? 18 : 2, width: 16, height: 16, background: isDark ? '#1D9E75' : 'white', borderRadius: '50%', transition: '0.2s' }} />
            </div>
            <MoonIcon color={isDark ? '#1D9E75' : mutedColor} />
          </div>
          <button onClick={onBack} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', border: 'none', background: 'transparent', color: '#e74c3c', fontSize: 13, cursor: 'pointer', width: '100%', borderRadius: 8 }}>
            <LogoutIcon color="#e74c3c" />
            <span>Выйти</span>
          </button>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={{ flex: 1, padding: 24, height: '100vh', overflow: 'hidden' }}>
        <div style={contentCardStyle} className="admin-scroll">
          {/* USERS */}
          {activeTab === 'users' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                <h2 style={{ fontSize: 18, fontWeight: 600 }}>Пользователи</h2>
                <button onClick={loadUsers} disabled={loadingUsers} style={btnStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                  {loadingUsers ? '...' : 'Обновить'}
                </button>
              </div>
              <div style={{ background: cardBg, borderRadius: 12, overflow: 'hidden', flexShrink: 0 }}>
                <div style={tableHeaderStyle}>
                  <span>Пользователь</span><span>Диктовка</span><span>Регистрация</span><span>Статус</span><span>Потоки</span><span>Роль</span><span>Действия</span>
                </div>
              </div>
              <div style={scrollAreaStyle}>
                {users.map(u => (
                  <div key={u.login} style={tableRowStyle}>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.name || u.login}</div>
                      <div style={{ fontSize: 11, color: mutedColor, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.login}</div>
                    </div>
                    <div style={{ color: mutedColor }}>{u.speechkitTotal || 0}</div>
                    <div style={{ color: mutedColor, fontSize: 12, whiteSpace: 'nowrap' }}>{u.registeredAt ? formatRegDate(u.registeredAt) : '—'}</div>
                    <div style={{ minWidth: 0 }}>
                      {u.isBlocked
                        ? <span style={{ color: '#e74c3c', fontSize: 12, whiteSpace: 'nowrap' }} title="Заблокирован">Заблокирован</span>
                        : <span style={{ color: '#27ae60', fontSize: 12, whiteSpace: 'nowrap' }} title="Активен">Активен</span>
                      }
                    </div>
                    <div>
                      {(() => {
                        const { asMember, asMentor } = streamsOf(u.login);
                        const empty = asMember.length === 0 && asMentor.length === 0;
                        if (empty) return <span style={{ color: mutedColor, fontSize: 12 }}>—</span>;
                        return (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
                            {asMember.map(st => (
                              <span key={'m' + st.id} title={`участник: ${st.name}`}
                                style={{ fontSize: 12, color: textColor, display: 'block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {st.name}
                              </span>
                            ))}
                            {asMentor.map(st => (
                              <span key={'n' + st.id} title={`наставник: ${st.name}`}
                                style={{ fontSize: 12, color: accent, display: 'block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {st.name} · наставник
                              </span>
                            ))}
                          </div>
                        );
                      })()}
                    </div>
                    <div>
                      {effectiveRole(u.login) === 'mentor'
                        ? <span style={{ color: accent, fontSize: 12 }}>Наставник</span>
                        : <span style={{ color: mutedColor, fontSize: 12 }}>Пользователь</span>
                      }
                    </div>
                    <div style={{ display: 'flex', gap: 3 }}>
                      {u.isBlocked
                        ? <button onClick={() => handleUnblockUser(u.login)} style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                          </button>
                        : <button onClick={() => handleBlockUser(u.login)} style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><line x1="18" y1="6" x2="6" y2="18"/></svg>
                          </button>
                      }
                      <button onClick={() => { setSelectedUser(u); setShowResetModal(true); setNewPassword(''); }} style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
                      </button>
                      <button onClick={() => handleDeleteUser(u.login)} style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                      </button>
                      {effectiveRole(u.login) === 'mentor' ? (
                        <button onClick={() => setStreamPicker(streamPicker && streamPicker.login === u.login && streamPicker.kind === 'mentor' ? null : { login: u.login, kind: 'mentor' })} style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${streamPicker && streamPicker.login === u.login && streamPicker.kind === 'mentor' ? accent : mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }} title={streamsOf(u.login).asMentor.length > 0 ? `Наставник: ${streamsOf(u.login).asMentor.map(st => st.name).join(', ')}` : 'Сделать наставником — выбрать потоки'}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                        </button>
                      ) : (
                        <button onClick={() => setStreamPicker(streamPicker && streamPicker.login === u.login && streamPicker.kind === 'mentor' ? null : { login: u.login, kind: 'mentor' })} style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${streamPicker && streamPicker.login === u.login && streamPicker.kind === 'mentor' ? accent : mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }} title="Сделать наставником — выбрать потоки">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                        </button>
                      )}
                      {(() => {
                        const memberOf = streamsOf(u.login).asMember;
                        const pickerOn = streamPicker && streamPicker.login === u.login && streamPicker.kind === 'member';
                        return (
                          <button
                            onClick={() => {
                              if (!pickerOn) loadStreams();
                              setStreamPicker(pickerOn ? null : { login: u.login, kind: 'member' });
                            }}
                            style={{ padding: '4px 6px', background: 'transparent', border: `1px solid ${pickerOn ? accent : mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                            title={memberOf.length > 0 ? `Поток: ${memberOf.map(st => st.name).join(', ')}` : 'Добавить в поток'}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={memberOf.length > 0 ? accent : mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
                          </button>
                        );
                      })()}
                    </div>
                  </div>
                ))}
              </div>

              {/* Модалка выбора потоков для выбранного человека — поверх карточки */}
              {streamPicker && (
                <div
                  onClick={closeStreamPicker}
                  style={{
                    position: 'fixed', inset: 0, zIndex: 1000,
                    background: 'rgba(0,0,0,0.45)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24
                  }}>
                <div
                  onClick={e => e.stopPropagation()}
                  className="admin-scroll"
                  style={{
                    width: '100%', maxWidth: 460, maxHeight: '80vh', overflowY: 'auto',
                    background: sidebarBg, borderRadius: 16, padding: 20,
                    border: `1px solid ${borderColor}`,
                    boxShadow: '0 18px 50px rgba(0,0,0,0.45)'
                  }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 12 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.4 }}>
                      {streamPicker.kind === 'mentor' ? 'Наставник в потоках: ' : 'Поток для: '}
                      <span style={{ color: accent, wordBreak: 'break-word' }}>{streamPicker.login}</span>
                    </div>
                    <button onClick={closeStreamPicker} style={{ marginLeft: 'auto', flexShrink: 0, padding: '4px 10px', background: 'transparent', border: `1px solid ${mutedColor}`, color: textColor, borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Закрыть</button>
                  </div>

                  {streams.length === 0 && (
                    <div style={{ fontSize: 12, color: mutedColor }}>Потоков нет — создайте их во вкладке «Потоки».</div>
                  )}

                  {streams.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {streams.map(st => {
                        const members = st.members || [];
                        const isMentorHere = streamPicker.kind === 'mentor' && isMentorOf(streamPicker.login, st.id);
                        const isMemberHere = streamPicker.kind === 'member' && isMemberOf(streamPicker.login, st.id);
                        const full = members.length >= MAX_MEMBERS;
                        // Переполненные скрываем у участников; для наставников лимит не действует
                        if (streamPicker.kind === 'member' && full && !isMemberHere) return null;
                        const active = streamPicker.kind === 'mentor' ? isMentorHere : isMemberHere;
                        return (
                          <button
                            key={st.id}
                            disabled={busyStreamAction}
                            onClick={() => streamPicker.kind === 'mentor' ? toggleMentorStream(streamPicker.login, st) : chooseMemberStream(streamPicker.login, st)}
                            style={{
                              display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left',
                              padding: '8px 12px', borderRadius: 10, cursor: busyStreamAction ? 'default' : 'pointer',
                              background: active ? (isDark ? 'rgba(29,158,117,0.16)' : 'rgba(29,158,117,0.10)') : 'transparent',
                              border: `1px solid ${active ? accent : borderColor}`, color: textColor, fontSize: 13
                            }}>
                            <span style={{ width: 16, display: 'inline-flex', justifyContent: 'center', color: active ? accent : mutedColor }}>
                              {active ? <Icons.check size={14} color={accent} /> : null}
                            </span>
                            <span style={{ flex: 1 }}>{st.name}</span>
                            <span style={{ fontSize: 11, color: mutedColor }}>{members.length}/{MAX_MEMBERS}</span>
                            {streamPicker.kind === 'member' && full && isMemberHere && (
                              <span style={{ fontSize: 11, color: '#e74c3c' }}>полный</span>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  )}

                  <div style={{ fontSize: 11, color: mutedColor, marginTop: 10 }}>
                    {streamPicker.kind === 'mentor'
                      ? 'Наставник может вести один или несколько потоков — нажмите, чтобы вкл/выкл.'
                      : 'Пользователь может быть только в одном потоке — выбор другого перенесёт его.'}
                  </div>
                </div>
                </div>
              )}
            </>
          )}

          {/* STREAMS (потоки чата) */}
          {activeTab === 'streams' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0, flexWrap: 'wrap' }}>
                <h2 style={{ fontSize: 18, fontWeight: 600 }}>Потоки (группы чата)</h2>
                <button onClick={async () => { loadStreamCandidates(); loadStreams(); }} disabled={loadingStreams} style={btnStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                  {loadingStreams ? '...' : 'Обновить'}
                </button>
              </div>

              {/* Быстрое создание */}
              <div style={{ display: 'flex', gap: 8, margin: '12px 0 16px', flexShrink: 0, background: cardBg, borderRadius: 12, padding: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: mutedColor, marginRight: 4 }}>Создать поток:</div>
                <input style={{ ...inputStyle, width: 240 }} placeholder="Название потока" value={newStreamName}
                  onChange={e => setNewStreamName(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') createStream(); }} />
                <button style={btnStyle} onClick={createStream}><span style={{ fontSize: 16, lineHeight: 1 }}>+</span> Создать</button>
                <div style={{ fontSize: 11, color: mutedColor, width: '100%' }}>У потока — до 10 участников и один или несколько наставников. Наставник/админ увидит поток в чате и разделе «Подопечные».</div>
              </div>

              <div style={scrollAreaStyle}>
                {streams.length === 0 && !loadingStreams && (
                  <div style={{ textAlign: 'center', padding: 40, color: mutedColor, fontSize: 14 }}>Потоков пока нет. Создайте первый!</div>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {streams.map(st => {
                    const expanded = editingStreamId === st.id;
                    return (
                      <div key={st.id} style={{ background: cardBg, borderRadius: 12, padding: '12px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <StreamsIcon color={accent} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            {renamingId === st.id ? (
                              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                                <input style={{ ...inputStyle, width: 220 }} autoFocus value={renameValue}
                                  onChange={e => setRenameValue(e.target.value)}
                                  onKeyDown={e => { if (e.key === 'Enter') renameStream(st.id); if (e.key === 'Escape') setRenamingId(null); }} />
                                <button onClick={() => renameStream(st.id)} style={btnStyle}>OK</button>
                                <button onClick={() => setRenamingId(null)} style={{ padding: '6px 10px', background: '#555', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Отмена</button>
                              </div>
                            ) : (
                              <div style={{ fontWeight: 600, fontSize: 15 }}>{st.name}</div>
                            )}
                          </div>
                          <div style={{ fontSize: 12, color: mutedColor, textAlign: 'center', whiteSpace: 'nowrap' }}>
                            <div><strong style={{ color: textColor }}>{st.members ? st.members.length : 0}</strong> участн.</div>
                            <div><strong style={{ color: accent }}>{st.mentors ? st.mentors.length : 0}</strong> настав.</div>
                          </div>
                          {!expanded && (
                            <button onClick={() => { setEditingStreamId(st.id); loadStreamCandidates(); }} style={btnStyle}>
                              Управлять
                            </button>
                          )}
                          {renamingId !== st.id && (
                            <button onClick={() => { setRenamingId(st.id); setRenameValue(st.name); }} title="Переименовать" style={{ padding: '6px 8px', background: 'transparent', border: `1px solid rgba(0,0,0,0)` }}>
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4v16h16v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                            </button>
                          )}
                          <button onClick={() => deleteStream(st)} title="Удалить поток" style={{ padding: '6px 8px', background: 'transparent', border: 'none', cursor: 'pointer' }}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                          </button>
                        </div>

                        {expanded && (
                          <div style={{ marginTop: 12, paddingTop: 12, borderTop: `1px solid ${borderColor}` }}>
                            {/* Участники */}
                            <div style={{ fontSize: 12, fontWeight: 600, color: mutedColor, marginBottom: 6 }}>УЧАСТНИКИ (до 10)</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                              {(st.members || []).map(m => (
                                <span key={'m' + m} style={{ background: isDark ? '#1b1b2f' : '#fff', border: `1px solid ${borderColor}`, borderRadius: 14, padding: '3px 8px 3px 11px', display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                                  {m}
                                  <button onClick={() => removePerson(st, m, 'member')} title="Убрать" style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex' }}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2.3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                  </button>
                                </span>
                              ))}
                              {(st.members || []).length === 0 && <span style={{ color: mutedColor, fontSize: 13 }}>пока пусто</span>}
                            </div>

                            {/* Наставники */}
                            <div style={{ fontSize: 12, fontWeight: 600, color: accent, marginBottom: 6 }}>НАСТАВНИКИ</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                              {(st.mentors || []).map(m => (
                                <span key={'mr' + m} style={{ background: isDark ? '#1b3a2a' : '#e8f5e9', borderRadius: 14, padding: '3px 8px 3px 11px', display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: accent }}>
                                  {m}
                                  <button onClick={() => removePerson(st, m, 'mentor')} title="Убрать" style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex' }}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2.3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                  </button>
                                </span>
                              ))}
                              {(st.mentors || []).length === 0 && <span style={{ color: mutedColor, fontSize: 13 }}>не назначен</span>}
                            </div>

                            {/* Добавить участника/наставника */}
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', background: bg, padding: 8, borderRadius: 10 }}>
                              <select style={{ ...inputStyle, width: 160 }} value={addRoleFor} onChange={e => setAddRoleFor(e.target.value)}>
                                <option value="member">Участник</option>
                                <option value="mentor">Наставник</option>
                              </select>
                              <select style={{ ...inputStyle, width: 210 }} value={addLoginFor} onChange={e => setAddLoginFor(e.target.value)}>
                                <option value="">— выберите логин —</option>
                                {streamUsers
                                  .filter(u => !(addRoleFor === 'member' ? (st.members || []) : (st.mentors || [])).includes(u.login))
                                  .map(u => <option key={u.login} value={u.login}>{u.login}{u.role === 'mentor' ? ' (наставник)' : ''}</option>)}
                              </select>
                              <button onClick={() => addPerson(st.id)} style={btnStyle}>Добавить</button>
                              <button onClick={() => { setEditingStreamId(null); setStreamUsers([]); }} style={{ padding: '6px 12px', background: 'transparent', border: `1px solid ${borderColor}`, borderRadius: 8, color: textColor, cursor: 'pointer', fontSize: 12 }}>Свернуть</button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}

          {/* MENTORS */}
          {activeTab === 'mentors' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                <h2 style={{ fontSize: 18, fontWeight: 600 }}>Наставники</h2>
                <button onClick={loadUsers} disabled={loadingUsers} style={btnStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                  {loadingUsers ? '...' : 'Обновить'}
                </button>
              </div>
              <div style={{ background: cardBg, borderRadius: 12, overflow: 'hidden', flexShrink: 0 }}>
                <div style={{ ...tableHeaderStyle, gridTemplateColumns: '1fr 1fr 1fr 100px 130px' }}>
                  <span>Логин</span><span>Имя</span><span>ID наставника</span><span>Статус</span><span>Действия</span>
                </div>
              </div>
              <div style={scrollAreaStyle}>
                {mentors.map(u => (
                  <div key={u.login} style={{ ...tableRowStyle, gridTemplateColumns: '1fr 1fr 1fr 100px 130px' }}>
                    <div style={{ fontWeight: 500 }}>{u.login}</div>
                    <div style={{ color: mutedColor }}>{u.name || '—'}</div>
                    <div style={{ fontSize: 12, color: mutedColor }}>{u.mentorId || '—'}</div>
                    <div>
                      {u.isBlocked
                        ? <span style={{ color: '#e74c3c', fontSize: 12 }}>Заблокирован</span>
                        : <span style={{ color: '#27ae60', fontSize: 12 }}>Активен</span>
                      }
                    </div>
                    <div style={{ display: 'flex', gap: 4 }}>
                      {u.isBlocked
                        ? <button onClick={() => handleUnblockUser(u.login)} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                          </button>
                        : <button onClick={() => handleBlockUser(u.login)} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><line x1="18" y1="6" x2="6" y2="18"/></svg>
                          </button>
                      }
                      <button onClick={() => { setSelectedUser(u); setShowResetModal(true); setNewPassword(''); }} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
                      </button>
                      <button onClick={() => handleDeleteUser(u.login)} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                      </button>
                      <button onClick={() => handleSetRole(u.login, 'user')} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }} title="Сделать пользователем">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                      </button>
                    </div>
                  </div>
                ))}
                {mentors.length === 0 && (
                  <div style={{ textAlign: 'center', padding: 40, color: mutedColor, fontSize: 14 }}>
                    Нет наставников
                  </div>
                )}
              </div>
            </>
          )}

          {/* PROMPTS */}
          {activeTab === 'prompts' && (
            <>
              <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16, flexShrink: 0 }}>Промпты</h2>
              <div style={{ ...scrollAreaStyle, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                {[
                  { label: 'Prompt 1 (разбор еды)', value: prompt1, set: setPrompt1, key: 'p1' },
                  { label: 'Prompt 2 (уже съел)', value: prompt2Ate, set: setPrompt2Ate, key: 'p2a' },
                  { label: 'Prompt 2 (планирую)', value: prompt2Plan, set: setPrompt2Plan, key: 'p2p' }
                ].map(p => (
                  <div key={p.key} style={{ background: cardBg, borderRadius: 12, padding: 14, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, flexShrink: 0 }}>{p.label}</div>
                    <textarea style={{ width: '100%', flex: 1, minHeight: 100, padding: 10, fontSize: 12, border: `1px solid ${borderColor}`, borderRadius: 8, background: bg, color: textColor, boxSizing: 'border-box', fontFamily: 'monospace', resize: 'none', outline: 'none', overflowY: 'auto' }} value={p.value} onChange={e => p.set(e.target.value)} />
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16, flexShrink: 0 }}>
                <button onClick={handleSavePrompts} disabled={isLoading} style={btnStyle}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                {saveBtnText}
              </button>
              </div>
            </>
          )}

          {/* RECOMMENDATIONS */}
          {activeTab === 'recommendations' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                <h2 style={{ fontSize: 18, fontWeight: 600 }}>Советы</h2>
                <button onClick={() => { setShowRecForm(true); setEditingRec(null); setRecForm({ id: null, categoryId: 'nutrition', title: '', content: '' }); }} style={btnStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  Добавить совет
                </button>
              </div>

              {showRecForm && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
                  onClick={() => setShowRecForm(false)}>
                  <div style={{ background: sidebarBg, borderRadius: 20, padding: 28, width: 400 }} onClick={e => e.stopPropagation()}>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>{editingRec ? 'Редактировать совет' : 'Добавить совет'}</div>
                    <input style={{ ...inputStyle, marginBottom: 10 }} placeholder="Заголовок" value={recForm.title} onChange={e => setRecForm({ ...recForm, title: e.target.value })} />
                    <textarea style={{ ...inputStyle, minHeight: 120, marginBottom: 10, fontFamily: 'inherit' }} placeholder="Содержание" value={recForm.content} onChange={e => setRecForm({ ...recForm, content: e.target.value })} />
                    <select style={inputStyle} value={recForm.categoryId} onChange={e => setRecForm({ ...recForm, categoryId: e.target.value })}>
                      {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                      {categories.length === 0 && <option value="nutrition">Питание</option>}
                      {categories.length === 0 && <option value="training">Похудение</option>}
                      {categories.length === 0 && <option value="perfect-meal">Идеальный прием пищи</option>}
                    </select>
                    <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                      <button onClick={editingRec ? handleUpdateRec : handleAddRec} style={btnStyle}>{editingRec ? 'Обновить' : 'Добавить'}</button>
                      <button onClick={() => setShowRecForm(false)} style={{ padding: '10px 24px', background: '#555', color: 'white', border: 'none', borderRadius: 10, fontSize: 13, cursor: 'pointer' }}>Отмена</button>
                    </div>
                  </div>
                </div>
              )}

              <div style={scrollAreaStyle}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {recommendations.map(rec => {
                    const cat = categories.find(c => c.id === rec.categoryId);
                    return (
                      <div key={rec.id} style={{ background: cardBg, borderRadius: 12, padding: 14 }}>
                        <div style={{ fontSize: 11, color: mutedColor, marginBottom: 4 }}>{cat ? cat.name : rec.categoryId}</div>
                        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>{rec.title}</div>
                        <div style={{ fontSize: 13, color: mutedColor, lineHeight: 1.4 }}>{rec.content.substring(0, 200)}{rec.content.length > 200 ? '...' : ''}</div>
                        <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                          <button onClick={() => handleEditRec(rec)} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                          </button>
                          <button onClick={() => handleDeleteRec(rec.id)} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16, flexShrink: 0 }}>
              <button onClick={handleSaveRecommendations} disabled={isLoading} style={btnStyle}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                {saveBtnText}
              </button>
              </div>
            </>
          )}

          {/* PROMOCODES */}
          {activeTab === 'promocodes' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                <h2 style={{ fontSize: 18, fontWeight: 600 }}>Промокоды</h2>
                <button onClick={async () => {
                  const d = await adminAction(ADMIN_PASSWORD, 'listPromos');
                  if (d.success) setPromocodes(d.promos);
                  else setMessage((d.error || 'Ошибка'));
                }} style={btnStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                  Обновить
                </button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16, flexShrink: 0, background: cardBg, borderRadius: 12, padding: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: mutedColor, marginBottom: 4 }}>Создать промокод</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <input style={{...inputStyle, flex:1, minWidth:100}} placeholder="Название тарифа" value={newPromoName} onChange={e => setNewPromoName(e.target.value)} />
                  <input style={{...inputStyle, width:120}} placeholder="Код" value={newPromoCode} onChange={e => setNewPromoCode(e.target.value.toUpperCase())} />
                  <input type="number" style={{...inputStyle, width:80}} placeholder="Диктовка" value={newPromoSkLimit} onChange={e => setNewPromoSkLimit(Number(e.target.value))} min="0" />
                  <input type="number" style={{...inputStyle, width:80}} placeholder="Анализ" value={newPromoDsLimit} onChange={e => setNewPromoDsLimit(Number(e.target.value))} min="0" />
                  <input type="number" style={{...inputStyle, width:80}} placeholder="Мес." value={newPromoDuration} onChange={e => setNewPromoDuration(Number(e.target.value))} min="0" />
                  <input type="date" style={{...inputStyle, width:130}} value={newPromoExpires} onChange={e => setNewPromoExpires(e.target.value)} />
                  <input type="number" style={{...inputStyle, width:60}} placeholder="Исп." value={newPromoMaxUses} onChange={e => setNewPromoMaxUses(Number(e.target.value))} min="1" />
                  <button style={btnStyle} onClick={async () => {
                    if (!newPromoCode.trim()) { setMessage('Введите код'); return; }
                    const d = await adminAction(ADMIN_PASSWORD, 'createPromo', {
                      code: newPromoCode.trim(),
                      name: newPromoName.trim() || 'Премиум',
                      speechkitLimit: newPromoSkLimit,
                      deepseekLimit: newPromoDsLimit,
                      durationMonths: newPromoDuration > 0 ? newPromoDuration : null,
                      expiresAt: newPromoExpires || null,
                      maxUses: newPromoMaxUses
                    });
                    if (d.success) {
                      setMessage(`Промокод ${newPromoCode} создан`);
                      setNewPromoCode(''); setNewPromoName('Премиум'); setNewPromoSkLimit(30);
                      setNewPromoDsLimit(100); setNewPromoDuration(1); setNewPromoExpires(''); setNewPromoMaxUses(10);
                      const d2 = await adminAction(ADMIN_PASSWORD, 'listPromos');
                      if (d2.success) setPromocodes(d2.promos);
                    } else setMessage((d.error || 'Ошибка'));
                  }}>Создать</button>
                </div>
              </div>

              <div style={scrollAreaStyle}>
                {promocodes.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 40, color: mutedColor }}>Нет промокодов. Создайте первый!</div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {/* Заголовки */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 14px', fontSize: 10, color: mutedColor, fontWeight: 600, letterSpacing: '0.3px' }}>
                      <span style={{ width: 100 }}>КОД</span>
                      <span style={{ width: 120 }}>НАЗВАНИЕ</span>
                      <span style={{ width: 70 }}>ДИКТ</span>
                      <span style={{ width: 70 }}>АНАЛИЗ</span>
                      <span style={{ width: 55 }}>МЕС</span>
                      <span style={{ width: 100 }}>ДО</span>
                      <span style={{ width: 50 }}>ИСП</span>
                      <span style={{ width: 80 }}>СОЗДАН</span>
                      <span style={{ flex: 1 }}></span>
                    </div>
                    {promocodes.map(p => (
                      <div key={p.code} style={{ background: cardBg, borderRadius: 10, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ width: 100, fontFamily: 'monospace', fontSize: 13, fontWeight: 600, color: accent }}>{p.code}</span>
                        <span style={{ width: 120, fontSize: 13, color: textColor }}>{p.name || '—'}</span>
                        <span style={{ width: 70, fontSize: 12, color: mutedColor }}>{p.speechkitLimit}</span>
                        <span style={{ width: 70, fontSize: 12, color: mutedColor }}>{p.deepseekLimit}</span>
                        <span style={{ width: 55, fontSize: 11, color: p.durationMonths ? '#1D9E75' : mutedColor }}>{p.durationMonths || '—'}</span>
                        <span style={{ width: 100, fontSize: 11, color: p.expiresAt && new Date(p.expiresAt) < new Date() ? '#e74c3c' : mutedColor }}>{p.expiresAt ? new Date(p.expiresAt).toLocaleDateString('ru-RU') : '—'}</span>
                        <span style={{ width: 50, fontSize: 11, color: mutedColor }}>{p.usedCount}/{p.maxUses}</span>
                        <span style={{ width: 80, fontSize: 10, color: mutedColor }}>{p.createdAt ? new Date(p.createdAt).toLocaleDateString('ru-RU') : '—'}</span>
                        <button onClick={async () => {
                          if (!window.confirm(`Удалить промокод ${p.code}?`)) return;
                          const d = await adminAction(ADMIN_PASSWORD, 'deletePromo', { code: p.code });
                          if (d.success) {
                            setMessage(`Промокод ${p.code} удалён`);
                            setPromocodes(promocodes.filter(x => x.code !== p.code));
                          } else setMessage((d.error || 'Ошибка'));
                        }} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}

          {/* INVITE CODES */}
          {activeTab === 'invitecodes' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                <h2 style={{ fontSize: 18, fontWeight: 600 }}>Коды приглашения</h2>
                <button onClick={async () => {
                  const d = await adminAction(ADMIN_PASSWORD, 'listInviteCodes');
                  if (d.success) setInviteCodes(d.codes || []);
                  else setMessage((d.error || 'Ошибка'));
                }} style={btnStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                  Обновить
                </button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16, flexShrink: 0, background: cardBg, borderRadius: 12, padding: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: mutedColor, marginBottom: 4 }}>Создать код приглашения</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <input style={{...inputStyle, width: 160, letterSpacing: 2, fontFamily: 'monospace'}} maxLength={6} inputMode="numeric" placeholder="6 цифр" value={newInviteCode} onChange={e => setNewInviteCode(e.target.value.replace(/\D/g, ''))} onKeyDown={e => { if (e.key === 'Enter') document.getElementById('create-code-btn').click(); }} />
                  <button id="create-code-btn" style={btnStyle} onClick={async () => {
                    if (!/^\d{6}$/.test(newInviteCode.trim())) { setMessage('Код должен быть ровно 6 цифр'); return; }
                    const d = await adminAction(ADMIN_PASSWORD, 'createInviteCode', { code: newInviteCode.trim() });
                    if (d.success) {
                      setMessage(`Код ${newInviteCode} добавлен`);
                      setNewInviteCode('');
                      if (d.codes) setInviteCodes(d.codes);
                    } else setMessage((d.error || 'Ошибка'));
                  }}>Создать</button>
                </div>
                <div style={{ fontSize: 11, color: mutedColor }}>Код из 6 цифр, многоразовый. Даётся людям для регистрации. Без него регистрация невозможна.</div>
              </div>

              <div style={scrollAreaStyle}>
                {inviteCodes.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 40, color: mutedColor }}>Пока нет ни одного кода. Создайте первый!</div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 14px', fontSize: 10, color: mutedColor, fontWeight: 600, letterSpacing: '0.3px' }}>
                      <span style={{ width: 200 }}>КОД</span>
                      <span style={{ flex: 1 }}>СТАТУС</span>
                      <span style={{ width: 80 }}></span>
                    </div>
                    {inviteCodes.map(code => (
                      <div key={code} style={{ background: cardBg, borderRadius: 10, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ width: 200, fontFamily: 'monospace', fontSize: 15, fontWeight: 700, color: accent, letterSpacing: 2 }}>{code}</span>
                        <span style={{ flex: 1, fontSize: 12, color: '#27ae60' }}>Активен</span>
                        <button onClick={async () => {
                          if (!window.confirm(`Удалить код ${code}?`)) return;
                          const d = await adminAction(ADMIN_PASSWORD, 'deleteInviteCode', { code });
                          if (d.success) {
                            setMessage(`Код ${code} удалён`);
                            if (d.codes) setInviteCodes(d.codes);
                          } else setMessage((d.error || 'Ошибка'));
                        }} style={{ padding: '4px 8px', background: 'transparent', border: `1px solid ${mutedColor}`, borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={mutedColor} strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Reset Password Modal */}
      {showResetModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowResetModal(false)}>
          <div style={{ background: sidebarBg, borderRadius: 20, padding: 28, width: 360 }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
              Сброс пароля: {selectedUser?.name}
            </div>
            <input style={inputStyle} type="password" placeholder="Новый пароль (мин. 4 символа)" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button onClick={handleResetPassword} disabled={isLoading} style={{ flex: 1, padding: 12, background: accent, color: 'white', border: 'none', borderRadius: 10, fontSize: 14, cursor: 'pointer' }}>{isLoading ? '...' : 'Сбросить'}</button>
              <button onClick={() => setShowResetModal(false)} style={{ flex: 1, padding: 12, background: '#555', color: 'white', border: 'none', borderRadius: 10, fontSize: 14, cursor: 'pointer' }}>Отмена</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;
